<template>
  <div class="crm-dashboard">
    <el-card class="data-work-dynamic" shadow="never">
      <div slot="header">
        <span>套餐信息</span>
      </div>
      <el-form ref="form" label-width="80px" label-position="right">
        <el-form-item label="套餐名称">
          {{packageDetail.packageName}}
        </el-form-item>
        <el-form-item label="套餐模块">
          {{packageDetail.modules}}
        </el-form-item>
        <el-form-item label="单价">
          {{packageDetail.packageSinglePrice}}元
        </el-form-item>
        <el-form-item label="订阅数量">
          {{packageDetail.buyCount}}
        </el-form-item>
        <el-form-item label="合计金额">
          {{packageDetail.packageTotalPrice}}元
        </el-form-item>
        <el-form-item label="有效期至">
          {{packageDetail.validityEndTime}}
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="data-funnel" shadow="never">
      <div slot="header">
        <span>系统公告</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card shadow="never" class="dynamicCard">
            <div>
              <div class="cardLeftTopTitle"> </div>
              <el-button type="text" class="moreBtn" @click="showMore()">更多>></el-button>
            </div>
            <div class="dynamicList" v-for="item in systemNoticeList">
              <div>{{item.createTime}}</div>
              <div class="dynamicContent">{{item.noticeTitle}}</div>
              <el-button type="text" class="toDetailBtn" @click="toDetail(item)">查看</el-button>
            </div>
            <div v-if="!systemNoticeList || systemNoticeList.length===0" class="noDataTip">暂无数据</div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <!--工作动态列表弹窗-->
    <el-dialog title="系统公告" :visible.sync="dynamicListVisible" width="45%" :close-on-click-modal="false">
      <div v-if="!noticeList || noticeList.length===0" class="noDataTip">暂无数据</div>
      <div class="dynamicList2" v-for="item in noticeList">
        <div>{{item.createTime}}</div>
        <div class="dynamicContent">{{item.noticeTitle}}</div>
        <el-button type="text" class="toDetailBtn" @click="toDetail(item)">查看</el-button>
      </div>
      <pagination 
        v-show="dynamicTotal>0" 
        :total="dynamicTotal" 
        :page.sync="queryParams.pageNum"
        :page-sizes="[5, 10, 20, 30]"
        :limit.sync="queryParams.pageSize" @pagination="queryNotice"/>
    </el-dialog>
  </div>
</template>

<script>
import { packageInfo, tenantNoticeList } from "@/api/saas/package";

export default {
  name: "index",
  props: {},
  data() {
    return {
      packageDetail: {}, // 套餐情况
      systemNoticeList: [],
      noticeList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 5
      },
      dynamicListVisible: false,
      dynamicTotal: 0,
    };
  },
  created() {
    this.packageInfo()
    this.tenantNoticeList()
  },
  methods: {
    // 系统公告
    tenantNoticeList() {
      tenantNoticeList({
        pageNum: 1,
        pageSize:4
      }).then(response => {
        this.systemNoticeList = response.rows
      });
    },
    queryNotice() {
      tenantNoticeList(this.queryParams).then(response => {
        this.noticeList = response.rows
        this.dynamicTotal = response.total
      });
    },
    packageInfo() {
      packageInfo().then(response => {
        this.packageDetail = response.data
      });
    },
    toDetail(item) {
      this.$router.push({
        path: '/system/noticeDetail',
        query: {
          noticeId: item.noticeId
        }
      })
    },
    showMore() {
      this.dynamicListVisible = true
      this.queryNotice()
      // this.$router.push({
      //   // TODO 有问题，待修改，不要跳页面，加个弹框，或者价格列表也
      //   path: '/system2/notice'
      // })
    }
  }
};
</script>

<style lang='scss'>
.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 20px;
        }
        .value {
          font-weight: 400;
          padding-top: 30px;
        }
      }
    }
    .data-card:hover {
      color: #4480f3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
    }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -16px!important;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    color: #9ea1a7;
    font-size: 14px;
  }

  .dynamicCard {
    min-height: 100px;
    height: auto!important;
  }

  .noDataTip {
    margin-left: 45%;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
  }

  .dynamicContent {
    margin-top: 8px;
    width: 96%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
</style>
